var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.38925 20.277975H220.018V32.4H216.47225V6H220.018V17.066H225.474L233.05325 6H237.19325L228.51 18.473975L238 32.4H233.64775L225.38925 20.277975Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.2205 9.234V19.640025H203.6885C205.7345 19.640025 207.22225 19.200025 208.11075 18.320025C208.9995 17.440025 209.454 16.14205 209.454 14.42605C209.454 12.71005 209.02 11.39005 208.1315 10.532075C207.243 9.67405 205.755 9.234 203.6885 9.234H197.2205ZM193.74875 6H205.321C210.136 6 212.8845 9.41005 212.8845 14.44805C212.8845 19.48605 210.012 22.89605 205.321 22.89605H197.2205V32.4H193.74875V6Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.401 21.818H184.4145L180.089 7.407975H178.705L174.401 21.818ZM175.35275 6L167.43725 32.4H171.222L173.42775 25.052H185.4525L187.572 32.4H191.35675L183.44125 6H175.331H175.35275Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.34175 6V32.4H139.98125V7.429975H140.566L147.43325 32.4H153.99725L160.821 7.429975H161.40575V32.4H165.04525V6H157.8315L151.00775 30.97H150.48775L143.64225 6H136.34175Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.03025 6V32.4H116.99375L127.4815 7.429975H127.991V32.4H131.55775V6H124.55175L114.08525 30.97H113.597V6H110.03025Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.24625 6H87.3065V32.4H105.24625V29.166H90.762V20.32195H102.8875V17.08795H90.762V9.211975H105.24625V6Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.341 6H59.799V32.4H63.341V20.277975H77.78475V32.4H81.32675V6H77.78475V17.066H63.341V6Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.578 0H114.814V3.6H125.578V0Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.150425 26.8305V11.569525H13.6692V26.8305H12.150425ZM25.8195 26.8305V11.569525H27.33825V26.8305H25.8195ZM14.69595 18.435875H24.792725V19.964125H14.69595V18.435875ZM36.42975 5.456525V8.513H39.46725V32.9435H36.42975V36H15.187975V32.9435H6.075175C2.7381 32.9435 0 30.18825 0 26.8305V8.513C0 5.15515 2.7381 2.4 6.075175 2.4H27.317V5.456525H6.075175C5.2409 5.456525 4.4922 5.800875 3.936025 6.360525C3.37985 6.920175 3.037625 7.673525 3.037625 8.513V26.8305C3.037625 27.67 3.37985 28.42325 3.936025 28.983C4.4922 29.5425 5.2409 29.887 6.075175 29.887H15.187975V32.9435H36.42975V8.513H27.317V5.456525H36.42975Z",
    fill: "#FD9968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fc1da68839b9149958e1c074c6fe382f.svg";
export { ForwardRef as ReactComponent };